import { findLocationModalStyles as styles } from "@insite/content-library/Components/FindLocationModal";
import { css } from "styled-components";

styles.searchResultSelectButton = {
    ...styles.searchResultSelectButton,
    variant: "secondary",
};

styles.siteMessageResultsErrorText = {
    ...styles.siteMessageResultsErrorText,
    css: css`
        ${styles.siteMessageResultsErrorText?.css}
        line-height: 1.2;
        padding-top: 16px;
    `,
};

styles.selectedWarehouseNameText = {
    ...styles.selectedWarehouseNameText,
    css: css`
        ${styles.selectedWarehouseNameText?.css}
        line-height: 1.2;
    `,
};


